import { getToken, getUser } from "../Utils/Common";
import { getAPICall, postAPICall } from "./axiosMethodCalls";
const user = getUser();
const token = getToken();

//GET
export const getBrand = async (data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "brands/get",
            {
                requester: user,
                token: token,
                name: data.name,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const createBrand = async (info) => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "brands/create",
            {
                requester: user,
                token: token,
                name: info.name,
            }
        );
        //
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const updateBrand = async (info) => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "brands/update",
            {
                requester: user,
                token: token,
                product_ids: info.id,
                name: info.name,
            }
        );
        //
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const deleteBrand = async (id) => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "brands/delete",
            {
                requester: user,
                token: token,
                product_ids: id,
            }
        );
        return { data: response };
    } catch (error) {
        return { error: error.response };
    }
};